import Judging from './Judging';

export default Judging;
